import { render, staticRenderFns } from "./AbwesenheitsTable.vue?vue&type=template&id=71f3d65b&scoped=true"
import script from "./AbwesenheitsTable.vue?vue&type=script&lang=js"
export * from "./AbwesenheitsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f3d65b",
  null
  
)

export default component.exports